import { safeParseNullDefault } from 'shouldve-been-js';

class SystemInfo {

    private _apiVersion: string | null;
    private _minAppVersion: string | null;

    public constructor(apiVersion: string | null, minAppVersion: string | null) {

        this._apiVersion = apiVersion;
        this._minAppVersion = minAppVersion;
    }

    public get apiVersion(): string | null {
        return this._apiVersion;
    }

    public set apiVersion(value: string | null) {
        this._apiVersion = value;
    }

    public get minAppVersion(): string | null {
        return this._minAppVersion;
    }

    public set minAppVersion(value: string | null) {
        this._minAppVersion = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): SystemInfo {

        const apiVersion: string | null = safeParseNullDefault<string>(json?.apiVersion, '');
        const minAppVersion: string | null = safeParseNullDefault<string>(json?.minAppVersionVesselManager, '');
        
        return new SystemInfo(apiVersion, minAppVersion);
    }
}

export default SystemInfo;